import { Routes } from '@angular/router';
import { LoginComponent } from './auth/login/login.component';
import { authGuard } from './auth/auth/auth.guard';
import { MainComponent } from './main/main.component';
import { InvoiceListComponent } from './invoice-capture/invoice-list/invoice-list.component';

export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'main', component: MainComponent, canActivate: [authGuard] },
  { path: 'invoices', component: InvoiceListComponent, canActivate: [authGuard] },
  { path: '**', redirectTo: 'main' },
];
